import React, { useEffect, useState } from "react";
import { GenericInput } from "../components/input/GenericInput";
import { Stack } from "@mui/material";
import { FormWrapper } from "../components/styled/StyledComponents";
import {
  sActive,
  sAddCategory,
  sCategories,
  SORT,
  sUpdateCategory,
} from "../constants/strings";
import { GenericSelect } from "../components/select/GenericSelect";
import { FormButton } from "../components/buttons/FormButton";
import { GenericSwitch } from "../components/elements/Switch";
import useForm from "../hooks/useForm";
import { useAppContext } from "../context/useAppContext";
import { useFirebase } from "../hooks/firebase/useFirebase";
import { CATEGORIES_API } from "../constants/api";
import { FileUploader } from "../components/upload/FileUploader";
import { ImageWrapper } from "../components/image/ImageViewer";
import { useUpload } from "../hooks/useUpload";

export const CategoryForm = ({ data, setOpen }) => {
  const { addData: addCategory, loading, updateData } = useFirebase();
  const {
    imageUrls: uploadedUrls,
    uploadImages,
    loading: uploading,
  } = useUpload();
  const { form, onChange, updateFormValue, updateFormValues } = useForm({
    active: true,
    sort: 0,
  });
  const { contextData } = useAppContext();
  const { topMenu = [] } = contextData;
  const [images, setImages] = useState([]);

  // update to incoming values
  useEffect(() => {
    updateFormValues(data);
  }, [data]);

  function handleAddCategory() {
    // update form
    form.imageUrls = uploadedUrls;
    // form.timestamp = timestamp;
    addCategory(
      CATEGORIES_API,
      form,
      updateFormValues({
        category_name: "",
      })
    );
  }

  function handleUpdate() {
    if (uploadedUrls.length > 0) {
      form.imageUrls = uploadedUrls;
    }
    updateData(data.docRef, form).then(() => {
      setOpen(false);
      // clear local images
      setImages([]);
    });
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (data) {
      // update data
      if (images.length > 0) {
        uploadImages(images, sCategories, handleUpdate);
      } else {
        handleUpdate();
      }
    } else {
      if (images.length > 0) {
        uploadImages(images, sCategories, handleAddCategory);
      } else {
        handleAddCategory();
      }
    }
  };

  return (
    <FormWrapper>
      <form onSubmit={onSubmit}>
        <Stack spacing={3}>
          {/* Images */}
          <ImageWrapper images={data?.imageUrls} />

          {/* Categories */}
          <GenericSelect
            value={form.parent}
            onChange={(value) => {
              updateFormValue("parent", value);
            }}
            label="Parent Category"
            options={[
              { value: "top-menu", label: "Top Menu" },
              ...topMenu?.map((category) => {
                return {
                  value: category.id,
                  label: category.category_name,
                };
              }),
            ]}
            required
          />

          {/* Name */}
          <GenericInput
            label="Category Name"
            required
            value={form.category_name}
            onChange={onChange}
            name="category_name"
          />

          {/* Sort */}
          <GenericInput
            label="Sort"
            type="number"
            required
            value={form.sort}
            onChange={onChange}
            name={SORT}
          />

          <FileUploader
            images={images}
            limit={1}
            size={0.1}
            setImages={setImages}
            label="Category Image"
            helperText="Minimum resolution 500 x 500 (1:1) recommended, upto 100KB."
          />

          <GenericSwitch
            checked={form.active}
            label={sActive}
            updateFormValue={updateFormValue}
          />
          {/* Submit */}
          <FormButton loading={uploading || loading}>
            {data ? sUpdateCategory : sAddCategory}
          </FormButton>
        </Stack>
      </form>
    </FormWrapper>
  );
};
